import React, { type SelectHTMLAttributes } from "react";

import classNames from "classnames";

import { ReactComponent as Icon_TriangleDown } from "../../assets/icons/TriangleDown.svg";

import style from "./Select.module.css";

export type SelectProps = {
  error?: boolean;
  errorMessage?: string;
};

export const Select = React.forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement> & SelectProps
>(({ error, errorMessage, ...attrs }, ref) => (
  <div className={classNames(style.wrapper, attrs.className)}>
    <div className={style.innerWrapper}>
      <select
        {...attrs}
        ref={ref}
        className={classNames(style.select, (error || errorMessage) && style.error)}
      >
        {attrs.children}
      </select>
      <Icon_TriangleDown className={style.icon} />
    </div>
    {errorMessage && <span className={style.errorMessage}>{errorMessage}</span>}
  </div>
));

Select.displayName = "Select";
